/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

export const ChannelsType = {
    ALL: 'allChannels',
    SUBSCRIBED: 'subscribedChannels',
    FAVORITE: 'favoriteChannels',
} as const;

export type ChannelsType = typeof ChannelsType[keyof typeof ChannelsType];
